module.exports = __webpack_public_path__ + "static/CristianZambranosub-75a9d8a71429dd9da99e05bcb2347800.mp4";